import React from 'react';
import { createPortal } from 'react-dom';

import { Box, CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';

import { DEFAULT_SCRIM_OPACITY, DEFAULT_SPINNER_SIZE } from './SavingOverlay.constants';
import {
  getContainerOverlayStyles,
  getFullScreenOverlayStyles,
  progressStyles,
} from './SavingOverlay.styles';

const SavingOverlay = ({
  isOpen,
  isFullScreen = false,
  scrimOpacity = DEFAULT_SCRIM_OPACITY,
  size = DEFAULT_SPINNER_SIZE,
}) => {
  if (!isOpen) {
    return null;
  }

  const overlay = (
    <Box
      sx={
        isFullScreen
          ? getFullScreenOverlayStyles(scrimOpacity)
          : getContainerOverlayStyles(scrimOpacity)
      }
    >
      <CircularProgress size={size} sx={progressStyles} />
    </Box>
  );

  return isFullScreen ? createPortal(overlay, document.body) : overlay;
};

SavingOverlay.propTypes = {
  isOpen: PropTypes.bool,
  isFullScreen: PropTypes.bool,
  scrimOpacity: PropTypes.number,
  size: PropTypes.number,
};

export default SavingOverlay;
